import React, { useState, useEffect } from 'react';
import getConfig from 'next/config';
import jsCookie from 'js-cookie';
import decode from 'jsonwebtoken/decode';

import useResponsive from '../../utils/hooks/useResponsive';
import useAuthenticated from '../../utils/hooks/useAuthenticated';

import navigations from '../../json/navigation.json';
import navigationsKronos from '../../json/navigation-kronos.json';

import { Navbar } from '@lifepal/lifepal-design-system';
import styles from './Navigation.module.scss';
import LoginModal from '../LoginModal';

const { ENABLE_OTP_LOGIN } = getConfig().publicRuntimeConfig;

const Navigation = () => {
  const authenticated = useAuthenticated();

  const { isDesktop } = useResponsive();

  const defaultNavigationMenu = [...navigations['user'], ...navigationsKronos.data];
  const [navigationMenu, setNavigationMenu] = useState(defaultNavigationMenu);
  const [initialName, setInitialName] = useState('');

  const [showLogin, setShowLogin] = useState(false);

  const getAuthenticatedUser = () => {
    if (authenticated) {
      const token = jsCookie.get('token');
      const user = decode(token);
      if (user && user.full_name) {
        const name = user.full_name
          .match(/(^\S\S?|\b\S)?/g)
          .join('')
          .match(/(^\S|\S$)?/g)
          .join('')
          .toUpperCase();
        if (name) {
          setInitialName(name);
        }
      }
    }
  };

  const handleAuthenticationMenu = () => {
    let filteredNavigationMenu;
    if (authenticated) {
      filteredNavigationMenu = defaultNavigationMenu.filter((nav) => nav.title !== 'Login');
    } else {
      filteredNavigationMenu = defaultNavigationMenu.filter((nav) => nav.title !== 'Akun Saya');
    }
    setNavigationMenu(filteredNavigationMenu);
  };

  const handleLogout = () => {
    if (authenticated) {
      jsCookie.remove('token');
      window.location.reload();
    }
  };

  useEffect(() => {
    getAuthenticatedUser();
    handleAuthenticationMenu();
  }, [authenticated]);

  const handleLogin = () => {
    if (ENABLE_OTP_LOGIN) {
      if (!authenticated) {
        setShowLogin(true);
      }
    } else {
      window.location.href = '/account/login';
    }
  };

  return (
    <div>
      <Navbar
        type={'user'}
        navigationMenu={navigationMenu}
        isAuthenticated={authenticated}
        isLargeScaleDisplay={isDesktop}
        logoPath="/asuransi/static/images/lifepal-logo.png"
        initialName={initialName !== '' ? initialName : 'LP'}
        handleLogin={handleLogin}
        handleLogout={handleLogout}
      />
      {showLogin && <LoginModal closeModalClick={() => setShowLogin(false)} />}
    </div>
  );
};

export default Navigation;
